module.exports = __webpack_public_path__ + "img/img_xc.b679f825.png";